import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {IAvailableTypes} from 'src/app/core/models/available-types.interface';
import {PageParams} from 'src/app/core/models/page-params.model';
import {SaleOrderInvoiceEditForm} from 'src/app/shared/popups/sale-order-invoice-edit-form/sale-order-invoice-edit-form.component';
import {
    FinalPurchaseInvoiceEditForm
} from 'src/app/shared/popups/final-purchase-invoice-edit-form/final-purchase-invoice-edit-form.component';
import {ISaleOrder} from '../../../models/sale-order.interface';
import {SaleOrderService} from '../../../services/sale-order.service';
import {SaleOrderInvoiceType} from 'src/app/shared/enums/sale-order-invoice-type.enum';
import {
    SaleOrderVatInvoiceEditForm
} from 'src/app/shared/popups/sale-order-vat-invoice-edit-form/sale-order-vat-invoice-edit-form.component';
import {NotificationService} from 'src/app/core/services/notification.service';

@Component({
    selector: 'eci-order-invoice',
    templateUrl: './order-invoice.component.html',
    styleUrls: ['./order-invoice.component.scss']
})
export class OrderInvoiceComponent implements OnInit, OnChanges {

    pageParams: PageParams = new PageParams();

    @Input() info: ISaleOrder;
    @Input() isCreateMode: boolean = true;
    @Input() availableTypes: IAvailableTypes;
    @Input() isAdmin: boolean = false;
    @Output() showLoader: EventEmitter<boolean> = new EventEmitter<boolean>(false);
    @Output() reloadEmit: EventEmitter<boolean> = new EventEmitter<boolean>(false);

    pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        // this.getList(e.pageIndex + 1, e.pageSize);
    }

    constructor(
        private saleOrderSvc: SaleOrderService,
        private dialog: MatDialog,
        private notify: NotificationService
    ) {
    }

    ngOnInit(): void {
        if (!this.info) {
            return;
        }
        this.dataSource = [...this.info.invoices];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.info) {
            return;
        }
        // To hide the VAT and FINAL PURCHASE INVOICE for sale-orders.
        this.info.invoices = this.info.invoices.filter((el) => {
            return el.type !== SaleOrderInvoiceType.VAT && el.type !== SaleOrderInvoiceType.FINAL_PURCHASE_INVOICE;
        });
        this.dataSource = [...this.info.invoices];
    }

    displayedColumns: string[] = [
        'invoiceDate',
        'invoiceType', // TODO MAYBE NEED TO CHANGE TO ENUM
        // 'generationType',
        'linkToView',
        'edit',
    ];
    dataSource = [];

    downloadInvoice(id): void {
        this.saleOrderSvc.downloadInvoice(id);
    }

    editInvoice(invoicedata): void {
        if (!invoicedata.id || !this.info) {
            return;
        }
        this.saleOrderSvc.getSaleOrderInvoiceData(this.info?.id, invoicedata.id).subscribe(value => {
            if (!value) {
                return;
            }
            let dialogRef: any;
            switch (invoicedata.type) {
                case SaleOrderInvoiceType.VAT:
                    dialogRef = this.dialog.open(SaleOrderVatInvoiceEditForm, {
                        maxHeight: '80vh',
                        width: '890px',
                    });
                    break;
                case SaleOrderInvoiceType.FINAL_PURCHASE_INVOICE:
                    dialogRef = this.dialog.open(FinalPurchaseInvoiceEditForm, {
                        maxHeight: '80vh',
                        width: '890px',
                    });
                    break;
                default:
                    dialogRef = this.dialog.open(SaleOrderInvoiceEditForm, {
                        maxHeight: '80vh',
                        width: '890px',
                    });
            }
            dialogRef.componentInstance.data = value;

            dialogRef.afterClosed().subscribe(value => {
                if (!value) {
                    return;
                }

                switch (invoicedata.type) {
                    case SaleOrderInvoiceType.VAT:
                        this.saleOrderSvc.updateInvoiceDataWithoutDatabaseChanges(value).subscribe(() => {
                            this.reloadEmit.emit(true);
                        });
                        break;
                    case SaleOrderInvoiceType.FINAL_PURCHASE_INVOICE:
                        this.saleOrderSvc.updateInvoiceDataWithoutDatabaseChanges(value).subscribe(() => {
                            this.reloadEmit.emit(true);
                        });
                        break;
                    default: {
                        this.showLoader.emit(true);
                        this.saleOrderSvc.updateSaleOrderInvoiceData(value).subscribe(() => {
                            this.reloadEmit.emit(true);
                            this.showLoader.emit(false);
                            this.notify.showSuccessMessage('Updated successfully');
                        });
                    }
                }
            });
        });
    }

    regenerateInvoice() {
        let ids: number[] = [];
        ids.push(this.info.id);
        this.saleOrderSvc.regenrateOrdersInvoice(ids).subscribe(data => {
            this.notify.showSuccessMessage('Invoice Regenerated successfully');
            this.reloadEmit.emit(true);
        }, err => {
            this.notify.showError('Something went wrong');
        });
    }
}
